import { render, staticRenderFns } from "./mock-el-select.vue?vue&type=template&id=4515be2b&"
import script from "./mock-el-select.vue?vue&type=script&lang=js&"
export * from "./mock-el-select.vue?vue&type=script&lang=js&"
import style0 from "./mock-el-select.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports